@if (showPanel$ | async) {
  <mat-expansion-panel class="panel">
    <mat-expansion-panel-header>
      <mat-panel-title>{{ 'ASSOCIATIONS.ACCOUNT.TITLE' | translate }}</mat-panel-title>
    </mat-expansion-panel-header>
    <ng-container *ngIf="accountGroupInfo$ | async as accountGroupInfo; else emptyState">
      <crm-association-card
        *ngIf="accountGroupInfo?.id !== ''"
        [cardData]="accountGroupInfo"
        [actions]="accountGroupActions$ | async"
        [showRemoveButton]="false"
      ></crm-association-card>
    </ng-container>
  </mat-expansion-panel>

  <ng-template #loadingButton>
    <button mat-stroked-button color="primary" class="button-create-account" type="button" disabled>
      <glxy-loading-spinner [size]="'small'"></glxy-loading-spinner>
    </button>
  </ng-template>

  <ng-template #emptyState>
    <ng-container>
      <button
        *ngIf="!isAccountGroupLoading(); else loadingButton"
        mat-stroked-button
        color="primary"
        class="button-create-account"
        (click)="createAccount()"
      >
        <mat-icon>add</mat-icon>
        {{ 'ASSOCIATIONS.ACCOUNT.CREATE_ACCOUNT' | translate }}
      </button>
      <p class="description">{{ 'ASSOCIATIONS.ACCOUNT.CREATE_DESCRIPTION' | translate }}</p>
    </ng-container>
  </ng-template>
}
